import React from 'react';
import { Container,Grid } from '@material-ui/core';
import HomeAbout from "../Home/About";
import ElectionCommissioner from "../../components/ElectionCommissioners";
import Breadcrumb from '../../components/Breadcrumb';
import translate from '../../translation.json';
import { lang } from '../../config/app.config';
import MessageFromCommissioner from '../Home/MessageFromCommissioner';

const AboutUs:React.FC = () =>{
  return(
    <>
      <Breadcrumb slug="about-us" routes={[{title:translate.translation[lang].about_us}]}/>
      <div className="text-center curveBackground">
        <h3 className="ecn-title-inv text-26">{translate.translation[lang].about_us}</h3>
      </div>
      <div className="section-padding-2">
        <Container maxWidth="lg">
          <HomeAbout/>
        </Container>
      </div> 
      <div className="bg-primary section-padding-2">
      {/* <HomeAbout/> */}
      <Container maxWidth="lg">
        <Grid container spacing={0} >
          <Grid item xs={12} lg={7} md={6} xl={6}>
            {/* <VoterList/> */}
            <MessageFromCommissioner/>
          </Grid>
          <Grid item xs={12} lg={5} md={6} xl={6}>
            <ElectionCommissioner/>
          </Grid>
        </Grid>
      </Container>
    </div>
    </>
  );
}

export default AboutUs;